/**
 * Helper to check if user has access to diagnostic customization
 */

export function canAccessDiagnosticCustomization(userEmail: string | undefined | null): boolean {
  if (!userEmail) {
    return false;
  }

  const allowedEmails = process.env.VUE_APP_DIAGNOSTIC_CUSTOMIZATION_ALLOWED_EMAILS || '';

  if (!allowedEmails) {
    return false;
  }

  const emailList = allowedEmails
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter((email) => email.length > 0);

  const normalizedUserEmail = userEmail.toLowerCase().trim();

  return emailList.includes(normalizedUserEmail);
}
